import { store } from '@/store/index'

const MinMaskMoney = {}
MinMaskMoney.install = Vue => {
  Vue.directive('MinMaskMoney', {
    update: (el, binding) => {
      const s = parseInt(binding.value)
      const digit = store.getters.selectedStore.currency_dec_digit
      const cts = store.getters.selectedStore.currency_thousands_sep
      const cdp = store.getters.selectedStore.currency_dec_point
      const currency_symbol = store.getters.selectedStore.currency_symbol
      const val = (s / 1).toFixed(digit).replace(cts, cdp)
      el.innerHTML = '- ' + currency_symbol + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, cts)
    },
    bind: function(el, binding, vnode) {
      const s = parseInt(binding.value)
      const digit = store.getters.selectedStore.currency_dec_digit
      const cts = store.getters.selectedStore.currency_thousands_sep
      const cdp = store.getters.selectedStore.currency_dec_point
      const currency_symbol = store.getters.selectedStore.currency_symbol
      const val = (s / 1).toFixed(digit).replace(cts, cdp)
      el.innerHTML = '- ' + currency_symbol + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, cts)
    }
  })
}

export default MinMaskMoney
